import React from 'react';

const BARS = [40, 65, 35, 80, 55, 90, 70];
const AVATARS = ['bg-black', 'bg-gray-700', 'bg-gray-500', 'bg-gray-300'];

export const ScreenDashboard = React.memo(() => (
  <div className="px-3 pt-2">
    <div className="text-sm font-semibold text-black mb-3 px-1">Dashboard</div>
    <div className="grid grid-cols-2 gap-2 mb-3">
      <div className="bg-black text-white rounded-xl p-2.5">
        <div className="text-[9px] opacity-80 uppercase tracking-wider">Faturamento</div>
        <div className="text-lg font-bold leading-tight mt-1">€12.4k</div>
        <div className="text-[9px] opacity-90 mt-0.5">+18% mês</div>
      </div>
      <div className="bg-white border border-gray-200 rounded-xl p-2.5">
        <div className="text-[9px] text-gray-500 uppercase tracking-wider">OS Concluídas</div>
        <div className="text-lg font-bold leading-tight mt-1 text-black">142</div>
        <div className="text-[9px] text-gray-500 mt-0.5">+24 esta semana</div>
      </div>
    </div>
    <div className="bg-white border border-gray-200 rounded-xl p-2.5 mb-2">
      <div className="text-[10px] font-semibold text-black mb-2">Últimos 7 dias</div>
      <div className="flex items-end justify-between gap-1 h-12">
        {BARS.map((h, i) => (
          <div key={i} className="flex-1 bg-gradient-to-t from-gray-300 to-black rounded-sm" style={{ height: `${h}%` }} />
        ))}
      </div>
    </div>
    <div className="bg-white border border-gray-200 rounded-xl p-2.5">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-[10px] text-gray-500">Equipe ativa</div>
          <div className="text-sm font-bold text-black">8 prestadores</div>
        </div>
        <div className="flex -space-x-1.5">
          {AVATARS.map((c, i) => (
            <div key={i} className={`w-6 h-6 rounded-full ${c} border-2 border-white`} />
          ))}
        </div>
      </div>
    </div>
  </div>
));
ScreenDashboard.displayName = 'ScreenDashboard';
